import { Text } from '@/components/ui/text'
import { api } from '@api'
import { Chat } from '@components'
import { useQuery } from '@tanstack/solid-query'
// Added createEffect
import { Show, createEffect } from 'solid-js'
// Added imports for your service layer
import { useService } from 'solid-services'
import { useChannel } from '../../features/chat/state' // Adjust path as needed

const ONE_WEEK_MS = 7 * 24 * 60 * 60 * 1000

async function fetchTradeLeadersChannelId(): Promise<string | undefined> {
  const sb = api()
  const { data, error } = await sb
    .from('channel')
    .select('id')
    .eq('name', 'trade-leaders')
    .limit(1)

  if (error) throw error
  return data?.[0]?.id
}

export default function TradeLeaders(props: { minimalist?: boolean, height: string }) {
  const { setActiveChannelId } = useService(useChannel)()

  const q = useQuery(() => ({
    queryKey: ['channel-id', 'trade-leaders'],
    queryFn: fetchTradeLeadersChannelId,
    staleTime: ONE_WEEK_MS, // cache freshness: 1 week
    gcTime: ONE_WEEK_MS,    // cache retention: 1 week
    retry: 1,
    placeholderData: undefined,
  }))

  const minimalist = props.minimalist ?? false

  // Sync the fetched ID to the global store
  createEffect(() => {
    if (q.data) {
      setActiveChannelId(q.data)
    }
  })

  return (
    <Show when={!q.isLoading} fallback={<Text>Loading…</Text>}>
      <Show
        when={q.data}
        fallback={<Text color="fg.muted">Channel “trade-leaders” not found.</Text>}
      >
        <Chat
          height={props.height}
          // currentChannelId is removed! The Chat component now reads from the store directly.
          setIsReadOnly={true}
          isMinimal
        />
      </Show>
    </Show>
  )
}
